import {
	Dialog,
	IconButton,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableRow,
	Typography,
	WithStyles,
} from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import CloseIcon from '@material-ui/icons/Close';
import { DropzoneArea } from 'material-ui-dropzone';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IRootState } from 'src/reducers';
import { IMessage } from '../actions/message';
import * as Actions from '../actions/quickModeContens';
import MessageDialog from '../components/MessageDialog';
import i18n from '../resources/i18n';
import Config from '../site.config.json';
import Progress from './Progress';
const styles = (theme: Theme) =>
	createStyles({
		closeIcon: {
			'&:hover': {
				backgroundColor: '#e9e3e3',
			},
			backgroundColor: '#e9e3e3',
			border: '0px',
			cursor: 'pointer',
			padding: '8px',
			position: 'absolute',
			right: '-20px',
			textAlign: 'center',
			top: '-20px',
			zIndex: 1000,
		},
		container: {
			overflow: 'hidden',
			padding: '10px',
		},
		dialog: {
			height: '400px',
			overflow: 'visible',
			width: '700px',
		},
		div_imageAddCell: {
			'-webkit-align-items': 'center',
			border: '0px',
		},
		dropzoneInput: {
			'@media (max-width: 600px)': {
				maxHeight: '28px',
				minHeight: '28px',
				width: '125px',
			},
			background: '#fff',
			borderColor: '#516ecb',
			borderRadius: '8px',
			maxHeight: '65px',
			minHeight: '65px',
			width: '300px',
		},
		icon: {
			'@media (max-width: 600px)': {
				width: '20px',
			},
			cursor: 'pointer',
			width: '28px',
		},
		iconCell: {
			'-webkit-align-items': 'center',
			border: '0px',
			width: '85px',
		},
		icons: {
			display: 'none',
		},
		image: {
			'@media (max-width: 600px)': {
				width: '125px',
			},
			cursor: 'pointer',
			marginRight: '25px',
			width: '300px',
		},
		imageCell: {
			'-webkit-align-items': 'center',
			border: '0px',
			display: 'flex',
			flexWrap: 'wrap',
		},
		image_next: {
			'@media (max-width: 600px)': {
				width: '125px',
			},
			marginRight: '25px',
			width: '300px',
		},
		nextCell: {
			'-webkit-align-items': 'center',
			border: '0px',
			padding: '0px 40px 0px 16px',
		},
		paper: {
			height: 'auto',
			padding: '20px',
			width: '100%',
		},
		text: {
			margin: '0px',
		},
		textContainer: {
			'@media (max-width: 600px)': {
				height: '25px',
				width: '125px',
			},
			display: 'table-cell',
			height: '65px',
			textAlign: 'center',
			verticalAlign: 'middle',
			width: '300px',
		},
		textStyle: {
			'@media (max-width: 600px)': {
				fontSize: '15px',
			},
			color: '#516ecb',
			fontSize: '25px',
		},
		title: {
			fontWeight: 'bold',
		},
	});

interface ITextProps {
	initFlg: boolean;
}

interface IState {
	Files: Actions.IFileInfo[];
	ImageSeq: number;
	height: string;
	loading: boolean;
	messages: IMessage[];
	openMessageDialog: boolean;
	preview: boolean;
	htmlUrl: string;
	confirmDialog: boolean;
	textDeleteKey: string;
	fileName: string;
}

class QuickModeText extends React.Component<IProps, IState> {
	protected uploadInput: React.RefObject<HTMLInputElement>;
	protected uploadForm: HTMLFormElement | null;
	public constructor(props: IProps) {
		super(props);
		this.state = {
			Files: [],
			ImageSeq: 1,
			confirmDialog: false,
			fileName: '',
			height: 'auto',
			htmlUrl: '',
			loading: false,
			messages: [],
			openMessageDialog: false,
			preview: false,
			textDeleteKey: '',
		};
		this.uploadInput = React.createRef();
		this.handleResize = this.handleResize.bind(this);
		this.errorMessageDialogClose = this.errorMessageDialogClose.bind(this);
		this.handleCloseDialog = this.handleCloseDialog.bind(this);
		this.handleDeleteConfirm = this.handleDeleteConfirm.bind(this);
		this.deleteFile = this.deleteFile.bind(this);
	}

	public componentDidMount() {
		this.handleResize();
		window.addEventListener('resize', this.handleResize);
		if (this.props.initFlg) {
			this.setState({
				Files: this.props.text,
			});
		} else {
			this.props.saveText([]);
		}
	}
	public componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}
	public handleResize() {
		const viewItem: string[] = this.props.viewItem;
		let height = window.screen.height - 420 + 'px';
		if (viewItem.length === 2) {
			height = window.screen.height - 800 + 'px';
		}
		this.setState({
			height,
		});
	}
	public dropRejected = (files: File[], event: any) => {
		if (files) {
			this.handleSelectFile(files);
		}
	};

	public drop = (files: File[], event: any) => {
		if (files) {
			this.handleSelectFile(files);
		}
	};

	public render() {
		const { classes } = this.props;
		const container: React.CSSProperties = {
			maxHeight: this.state.height,
			minHeight: '120px',
			overflowX: 'hidden',
			overflowY: 'auto',
		};
		const DropzoneAreaBaseClasses = {
			icon: classes.icons,
			text: classes.text,
			textContainer: classes.textContainer,
		};
		return (
			<>
				<Paper className={classes.paper}>
					<Progress open={this.state.loading} />
					<Typography
						variant="h6"
						color="primary"
						className={classes.title}
					>
						{i18n.t('QuickModeText_0000')}
					</Typography>
					<div
						className={classes.container}
						style={container}
						id="container"
					>
						<Table>
							<TableBody>
								{this.state.Files.length > 0 &&
									this.state.Files.map((file, i) => {
										return (
											<React.Fragment key={i}>
												<TableRow>
													<TableCell
														className={
															classes.iconCell
														}
													>
														<img
															src={require('../images/icon-delete-red.png')}
															className={
																classes.icon
															}
															onClick={this.handleDeleteConfirm(
																file.key
															)}
														/>
													</TableCell>
													<TableCell
														className={
															classes.imageCell
														}
													>
														<img
															src={
																file.type ===
																'Image'
																	? require('../images/image.png')
																	: require('../images/video.png')
															}
															className={
																classes.image
															}
															onClick={this.openPreview(
																file.htmlFile
																	.htmlUrl
															)}
														/>
														<Typography
															variant="h6"
															color="textPrimary"
														>
															{file.name +
																'(' +
																file.size +
																')'}
														</Typography>
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell
														className={
															classes.iconCell
														}
													/>
													<TableCell
														className={
															classes.nextCell
														}
													>
														<img
															src={require('../images/Next.png')}
															className={
																classes.image_next
															}
														/>
													</TableCell>
												</TableRow>
											</React.Fragment>
										);
									})}
								<TableRow>
									<TableCell className={classes.iconCell}>
										<img
											src={require('../images/icon-delete-gray.png')}
											className={classes.icon}
										/>
									</TableCell>
									<TableCell
										className={classes.div_imageAddCell}
									>
										<DropzoneArea
											classes={DropzoneAreaBaseClasses}
											dropzoneText={'+'}
											dropzoneClass={
												classes.dropzoneInput
											}
											dropzoneParagraphClass={
												classes.textStyle
											}
											filesLimit={1}
											showAlerts={false}
											showPreviews={false}
											showPreviewsInDropzone={false}
											showFileNamesInPreview={false}
											onDropRejected={this.dropRejected}
											onDrop={this.drop}
										/>
									</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</div>
				</Paper>
				<MessageDialog
					open={this.state.openMessageDialog}
					showCancelButton={false}
					title={i18n.t('QuickModeText_0001')}
					contents={this.state.messages}
					onClose={this.errorMessageDialogClose}
					onClickOk={this.errorMessageDialogClose}
				/>
				<MessageDialog
					open={this.state.confirmDialog}
					showCancelButton={true}
					title={i18n.t('QuickModeText_0002')}
					contents={this.state.messages}
					onClose={this.errorMessageDialogClose}
					onClickOk={this.deleteFile}
				/>
				<Dialog
					fullScreen={false}
					fullWidth={true}
					maxWidth={false}
					open={this.state.preview}
					onClose={this.handleCloseDialog}
					aria-labelledby="simple-dialog-title"
					classes={{
						paperFullWidth: this.props.classes.dialog,
					}}
				>
					<IconButton
						color="inherit"
						aria-label="Close"
						className={classes.closeIcon}
						onClick={this.handleCloseDialog}
					>
						<CloseIcon />
					</IconButton>
					<iframe
						frameBorder="0"
						title="QuickMode"
						name="QuickMode"
						width="100%"
						height="100%"
						src={this.state.htmlUrl}
					/>
				</Dialog>
			</>
		);
	}

	protected openPreview = (htmlUrl: string) => () => {
		if (htmlUrl) {
			this.setState({
				htmlUrl,
				preview: true,
			});
		}
	};

	protected handleCloseDialog() {
		this.setState({
			htmlUrl: '',
			preview: false,
		});
	}

	protected errorMessageDialogClose() {
		this.setState({
			confirmDialog: false,
			messages: [],
			openMessageDialog: false,
			textDeleteKey: '',
		});
	}

	protected deleteFile() {
		const { textDeleteKey } = this.state;
		const Files: Actions.IFileInfo[] = this.state.Files.filter(
			item => item.key !== textDeleteKey
		);
		this.setState({
			Files,
			confirmDialog: false,
			messages: [],
			openMessageDialog: false,
			textDeleteKey: '',
		});
		this.props.saveText(Files);
	}

	// 添付ボタン押下時ハンドラ
	protected uploadFile = () => {
		if (!this.uploadInput.current) {
			return;
		}
		this.uploadInput.current.click();
	};
	protected handleSelectFile = (files: File[]) => {
		const uploadFile = files[0];
		const uploadFileName = uploadFile.name.toLowerCase();
		const messages: IMessage[] = [];

		const regex = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g;
		if (regex.test(uploadFile.name)) {
			const message: IMessage = {
				content: 'LMCM_E_16031',
				replacements: [],
			};
			messages.push(message);
			this.setState({
				messages,
				openMessageDialog: true,
			});
			return;
		}
		if (
			!uploadFileName.endsWith('.png') &&
			!uploadFileName.endsWith('.jpg') &&
			!uploadFileName.endsWith('.jpeg') &&
			!uploadFileName.endsWith('.gif') &&
			!uploadFileName.endsWith('.mp4') &&
			!uploadFileName.endsWith('.ogg') &&
			!uploadFileName.endsWith('.ogv') &&
			!uploadFileName.endsWith('.webm')
		) {
			const message: IMessage = {
				content: 'LMCM_E_16025',
				replacements: [],
			};
			messages.push(message);
			this.setState({
				messages,
				openMessageDialog: true,
			});
			return;
		}
		if (this.props.fileSize) {
			const size = Number.parseInt(this.props.fileSize) * 1048576;
			if (uploadFile.size > size) {
				const message: IMessage = {
					content: 'LMCM_E_16029',
					replacements: [this.props.fileSize],
				};
				messages.push(message);
				this.setState({
					messages,
					openMessageDialog: true,
				});
				return;
			}
		}

		const Files = this.state.Files;
		const timestamp = new Date().valueOf();
		this.setState({
			loading: true,
		});
		const form = new FormData();
		const modelData = {
			per_quickMode_contentsUpload: {
				courseFolder: this.props.courseFolder,
				fileName: uploadFile.name,
				imageNumber: this.state.ImageSeq,
				menuItemType: 'TEXT_PAGE_MENU_ITEM',
			},
		};
		form.append('__modelData', JSON.stringify(modelData));
		form.append('file', uploadFile);
		const request = new XMLHttpRequest();
		request.open(
			'POST',
			Config.tsqPath + '/tsq/ui/common/resources/rest/file/upload',
			true
		);
		request.setRequestHeader('Accept', 'application/json');
		request.send(form);
		request.onreadystatechange = () => {
			if (request.readyState === 4) {
				if (request.status === 200) {
					this.setState({
						loading: false,
					});
					const response = JSON.parse(request.responseText);
					if (response.per_quickMode_contentsUpload) {
						if (response.per_quickMode_contentsUpload.errorCode) {
							const message: IMessage = {
								content:
									response.per_quickMode_contentsUpload
										.errorCode,
								replacements: [],
							};
							messages.push(message);
							this.setState({
								messages,
								openMessageDialog: true,
							});
						} else if (
							response.per_quickMode_contentsUpload.htmlFile
						) {
							const htmlFile =
								response.per_quickMode_contentsUpload.htmlFile;
							let size = uploadFile.size / 1073741828;
							let unit = 'GB';
							if (size < 1) {
								size = uploadFile.size / 1048576;
								unit = 'MB';
								if (size < 1) {
									size = uploadFile.size / 1024;
									unit = 'KB';
								}
							}
							let imageFlg = false;
							if (
								uploadFileName.endsWith('.png') ||
								uploadFileName.endsWith('.jpg') ||
								uploadFileName.endsWith('.jpeg') ||
								uploadFileName.endsWith('.gif')
							) {
								imageFlg = true;
							}
							const file: Actions.IFileInfo = {
								htmlFile,
								key: uploadFileName + timestamp.toString(),
								name: uploadFileName,
								size: size.toFixed(1).toString() + unit,
								type: imageFlg ? 'Image' : 'Video',
							};
							if (imageFlg) {
								const seq = this.state.ImageSeq + 1;
								this.setState({
									ImageSeq: seq,
								});
							}
							Files.push(file);
							this.setState({
								Files,
							});
							this.props.saveText(Files);
						}
					} else if (response.tsqErrorMessage) {
						const message: IMessage = {
							content: response.tsqErrorMessage[0].message,
							replacements: response.tsqErrorMessage[0].strArray,
						};
						messages.push(message);
						this.setState({
							messages,
							openMessageDialog: true,
						});
					}
				}
				this.setState({
					loading: false,
				});
				const container = document.getElementById(
					'container'
				) as HTMLInputElement;
				if (container.scrollHeight) {
					container.scrollTop = container.scrollHeight;
				}
			}
		};
	};

	protected handleDeleteConfirm = (key: string) => (event: any) => {
		const messages: IMessage[] = [];
		const message: IMessage = {
			content: 'LMCM_E_16032',
			replacements: [],
		};
		messages.push(message);
		this.setState({
			confirmDialog: true,
			messages,
			textDeleteKey: key,
		});
	};
}

const mapStateToProps = (state: IRootState) => ({
	courseFolder: state.quickModeContents.courseFolder,
	fileSize: state.quickModeContents.fileSize,
	text: state.quickModeContents.text,
	token: state.session.token,
	userAttr: state.session.userAttr,
	viewItem: state.quickModeContents.viewItem,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	saveText: (files: Actions.IFileInfo[]) => {
		dispatch(Actions.setText({ files }));
	},
});

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & ITextProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(QuickModeText);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/components/QuickModeText.tsx